import React from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
import Button from "../Button";

const OrderNowBanner = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="order-now-banner layout desktop:container-desktop mobile:container-mobile tablet:container-mobile">
        <div className="desktop:desktop-h1 mobile:mobile-h1 tablet:tablet:h1"></div>
        <div className="info desktop:desktop-body1 mobile:mobile-body1 tablet:tablet:body1">
          {t("orderBannerInfo")}
          <span>{t("orderBannerInfo2")}</span>
          {t("orderBannerInfo3")}
        </div>
        <Button text={t("freshnessThisWay")} variant={3} />
      </div>
      <div className="banner layout desktop:container-desktop mobile:container-mobile tablet:container-mobile">
        <div className="divider"></div>
        <div className="banner-text">
          <p className="desktop:desktop-h1 mobile:mobile-h1 tablet:mobile-h1 marquee">
            <span>{t("bannerText")}&nbsp;</span>
            <span>{t("bannerText")}&nbsp;</span>
            <span>{t("bannerText")}&nbsp;</span>
          </p>
        </div>
      </div>
    </>
  );
};

export default OrderNowBanner;
